import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import { format } from "date-fns";
import { getErrorsMessage } from '../utils.js';
import { LangContext } from "../LangContext.jsx";
class ProviderDossierTypesPanel extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            data: null,
        };
    }

    componentDidMount() {
        this.getData()
    }

    async getData(){
        const res = await axios.get('/api/providers/statistics/')
        res.data.dossiersProviders.forEach(function(row, i){
            if(row.title == "Nacional") row.color = 'danger';
            if(row.title == "Internacional") row.color = 'success';
            if(row.title == "Especiales") row.color = 'info';
            if(row.title == "Otros") row.color = 'warning';

            row.percentage = (row.total*100) / res.data.totalDossierProviders;
        });

        res.data.dossiersEmployees.forEach(function(row, i){
            if(row.title == "Nacional") row.color = 'danger';
            if(row.title == "Internacional") row.color = 'success';
            if(row.title == "Especiales") row.color = 'info';
            if(row.title == "Otros") row.color = 'warning';

            row.percentage = ((row.total * 100) / res.data.totalDossierEmployees).toFixed(2);
        });

        res.data.dossiersClients.forEach(function(row, i){
            if(row.title == "Nacional") row.color = 'danger';
            if(row.title == "Internacional") row.color = 'success';
            if(row.title == "Especiales") row.color = 'info';
            if(row.title == "Otros") row.color = 'warning';

            row.percentage = ((row.total * 100) / res.data.totalDossierClients).toFixed(2);
        });

        this.setState({data: res.data})
    }

    render() {
        const { lang } = this.context; 
        return (<div>
            <div className="row mb-2">
                <div className="col-5">
                    <h3 className="card-title m-0">
                        <span className="card-label font-weight-bolder font-size-h4 text-dark-75">{lang.get('messages.tipos_de_expedientes')}</span>
                    </h3>
                </div>
                <div className="col-7">
                    <ul className="nav nav-pills nav-pills-sm nav-dark">
                        <li className="nav-item ml-0">
                            <a className="nav-link py-2 px-4 active font-weight-bolder font-size-sm" data-toggle="tab" href="#te_proveedores">{lang.get('messages.proveedores')}</a>
                        </li>
                        <li className="nav-item ml-0">
                            <a className="nav-link py-2 px-4 font-weight-bolder font-size-sm" data-toggle="tab" href="#te_empleados">{lang.get('messages.empleados')}</a>
                        </li>
                        <li className="nav-item ml-0">
                            <a className="nav-link py-2 px-4 font-weight-bolder font-size-sm" data-toggle="tab" href="#te_clientes">{lang.get('messages.clientes')}</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="tab-content">
                <div className="tab-pane fade show active" id="te_proveedores" role="tabpanel" aria-labelledby="te_proveedores">
                    <div className="row">
                        <div className="col-8">
                            <div className="flex-row-fluid pt-8">
                                <span className="text-dark-75 font-weight-bolder display4">
                                    { this.state.data == null ? 0 : this.state.data.totalDossierProviders } {lang.get('messages.de')} { this.state.data == null ? 0 : this.state.data.total }
                                    <span className="text-muted font-size-h5 font-weight-bold pl-2">{lang.get('messages.expedientes_de_proveedores')} </span>
                                </span>
                                <div className="progress mt-3">
                                    { this.state.data?.dossiersProviders.map((d, i) => {
                                        return  <div    key={i}
                                                        className={"progress-bar _rounded _mr-n3  bg-"+d.color+" zindex-"+i}
                                                        role="progressbar"
                                                        style={{ width: d.percentage+"%" }}
                                                        aria-valuenow="15"
                                                        aria-valuemin="0"
                                                        aria-valuemax="100"
                                                ></div>
                                    })}
                                </div>
                            </div>
                        </div>
                        <div className="col-4">
                            { this.state.data?.dossiersProviders.map((d, i) => {
                                return  <div className="mt-4" key={i}>
                                            <a style={{ width: '19px', height: '19px'}} href="#" className={ "btn btn-xs btn-icon mr-2 btn-" + d.color }>&nbsp;</a>
                                            <span className="text-dark-75 mb-1 font-weight-bolder font-size-lg">{d.title}</span>
                                        </div>
                            })}
                        </div>
                    </div>
                </div>
                <div className="tab-pane fade show" id="te_empleados" role="tabpanel" aria-labelledby="te_empleados">
                    <div className="row">
                        <div className="col-8">
                            <div className="flex-row-fluid pt-8">
                                <span className="text-dark-75 font-weight-bolder display4">
                                    { this.state.data == null ? 0 : this.state.data.totalDossierEmployees } {lang.get('messages.de')} { this.state.data == null ? 0 : this.state.data.total }
                                    <span className="text-muted font-size-h5 font-weight-bold pl-2">{lang.get('messages.expedientes_de_empleados')}</span>
                                </span>
                                <div className="progress mt-3">
                                    { this.state.data?.dossiersEmployees.map((d, i) => {
                                        return  <div    key={i}
                                                        className={"progress-bar rounded mr-n3 bg-"+d.color+" zindex-"+i}
                                                        role="progressbar"
                                                        style={{ width: d.percentage+"%" }}
                                                        aria-valuenow="15"
                                                        aria-valuemin="0"
                                                        aria-valuemax="100"
                                                ></div>
                                    })}
                                </div>
                            </div>
                        </div>
                        <div className="col-4">
                            { this.state.data?.dossiersEmployees.map((d, i) => {
                                return  <div className="mt-4" key={i}>
                                            <a style={{ width: '19px', height: '19px'}} href="#" className={ "btn btn-xs btn-icon mr-2 btn-" + d.color }>&nbsp;</a>
                                            <span className="text-dark-75 mb-1 font-weight-bolder font-size-lg">{d.title}</span>
                                        </div>
                            })}
                        </div>
                    </div>
                </div>
                <div className="tab-pane fade show" id="te_clientes" role="tabpanel" aria-labelledby="te_clientes">
                    <div className="row">
                        <div className="col-8">
                            <div className="flex-row-fluid pt-8">
                                <span className="text-dark-75 font-weight-bolder display4">
                                    { this.state.data == null ? 0 : this.state.data.totalDossierClients } de { this.state.data == null ? 0 : this.state.data.total }
                                    <span className="text-muted font-size-h5 font-weight-bold pl-2">{lang.get('messages.expedientes_de_clientes')}</span>
                                </span>
                                <div className="progress mt-3">
                                    { this.state.data?.dossiersClients.map((d, i) => {
                                        return  <div    key={i}
                                                        className={"progress-bar rounded mr-n3 bg-"+d.color+" zindex-"+i}
                                                        role="progressbar"
                                                        style={{ width: d.percentage+"%" }}
                                                        aria-valuenow="15"
                                                        aria-valuemin="0"
                                                        aria-valuemax="100"
                                                ></div>
                                    })}
                                </div>
                            </div>
                        </div>
                        <div className="col-4">
                            { this.state.data?.dossiersClients.map((d, i) => {
                                return  <div className="mt-4" key={i}>
                                            <a style={{ width: '19px', height: '19px'}} href="#" className={ "btn btn-xs btn-icon mr-2 btn-" + d.color }>&nbsp;</a>
                                            <span className="text-dark-75 mb-1 font-weight-bolder font-size-lg">{d.title}</span>
                                        </div>
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>);
    }
}

export default ProviderDossierTypesPanel;

if (document.getElementById('ProviderDossierTypesPanel')) {
    ReactDOM.render(<ProviderDossierTypesPanel />, document.getElementById('ProviderDossierTypesPanel'));
}
